import { FC, PropsWithChildren, useContext } from 'react';
import HelpCenterContext from '@providers/HelpCenterProvider/model/HelpCenterContext';
import styles from './Tooltip.module.scss';

/**
 * @param questionId - Indicates the DB Question ID to load in the Help Sidebar.
 * @param bottom - Indicates will tooltip be in the bottom.
 */
interface TooltipProps extends PropsWithChildren {
  questionTitle?: string;
  bottom?: boolean;
}

/**
 * @param props - The props for the component.
 * @returns A React component that displays a tooltip.
 */
const Tooltip: FC<TooltipProps> = (props) => {
  const { setIsHelpCenterOpened, setTargetTargetQuestionTitle } =
    useContext(HelpCenterContext);
  const { children, bottom = false, questionTitle } = props;

  function showHelpCenterQuestion(questionTitle: string | undefined) {
    if (!questionTitle) {
      return;
    }
    setIsHelpCenterOpened(true);
    setTargetTargetQuestionTitle(questionTitle);
  }

  return (
    <div
      onClick={() => showHelpCenterQuestion(questionTitle)}
      className={[styles.tooltip, bottom && styles.bottom].join(' ')}
    >
      <img src="/icons/tooltip.svg" />
      <p>{children}</p>
    </div>
  );
};

export default Tooltip;
